import { render, staticRenderFns } from "./ConfigurationPage.vue?vue&type=template&id=68de908c&scoped=true&lang=pug&"
import script from "./ConfigurationPage.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68de908c",
  null
  
)

export default component.exports